import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatResponse } from '../models/chat-message.interface';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  startConversation(token: string, schemaId: string, moduleSlugName: string, selectedOrgId: string, email: string, environmentName: string) {
		return this.http.post<{ conversationId: string; welcomeMessage: string }>(`${this.baseUrl}/start-conversation`, {
      token,
      customerId: selectedOrgId,
      moduleSlugName,
	    schemaId,
      email,
      environmentName
    });
  }

  sendMessage(conversationId: string, schemaId: string, token: string, moduleSlugName: string, environmentName: string, question: string, email: string) {
    return this.http.post<ChatResponse>(`${this.baseUrl}/chat`, {
      conversationId,
      schemaId,
      token,
      moduleSlugName,
      environmentName,
      question,
      email
    });
  }

  submitReview(userEmail: string, question: string, answer: string, isHelpful: boolean) {
    return this.http.post<{ success: boolean; message: string }>(`${this.baseUrl}/review`, {
      userEmail,
      question,
      answer,
      isHelpful
    });
  }
}
